export default __webpack_public_path__ + "static/lizSpeechDefence-f871ef37aacd767977657dd8979af4ed.svg";